// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-link {\n  color: var(--v-link-base) !important;\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
